const glonav = () => {
  const glonavBtn = document.querySelector('#header-nav-btn')
  const glonavClose = document.querySelector('#header-nav-close-btn')
  const openCls = 'is-globalnav-open'

  glonavBtn.addEventListener('click', () => {
    document.body.classList.toggle(openCls)
  })

  glonavClose.addEventListener('click', () => {
    if (document.body.classList.contains(openCls)) {
      document.body.classList.remove(openCls)
    }
  })

}

export default glonav